let AmplitudeEvents = /*#__PURE__*/function (AmplitudeEvents) {
  AmplitudeEvents["ADD_PARCEL"] = "Add Parcel";
  AmplitudeEvents["HELP"] = "Help";
  AmplitudeEvents["TRACKING"] = "Tracking";
  AmplitudeEvents["START_CHECKOUT"] = "Continue To Service";
  AmplitudeEvents["SELECT_SERVICE"] = "Select Service";
  AmplitudeEvents["LIST_SERVICES"] = "See Services List";
  AmplitudeEvents["CONTENT_VALUE"] = "Content Value";
  AmplitudeEvents["START_BOOKING"] = "Start Booking";
  AmplitudeEvents["SELECT_FROM_COUNTRY"] = "Select From Country";
  AmplitudeEvents["SELECT_TO_COUNTRY"] = "Select To Country";
  AmplitudeEvents["SET_WEIGHT"] = "Weight";
  AmplitudeEvents["SET_WIDTH"] = "Width";
  AmplitudeEvents["SET_HEIGHT"] = "Height";
  AmplitudeEvents["SET_LENGTH"] = "Length";
  AmplitudeEvents["SEARCH_FAILED"] = "Search Failed";
  AmplitudeEvents["PROMO_EMAILS"] = "Promo Emails";
  AmplitudeEvents["PAYMENT_SUCCESS"] = "Payment Success";
  AmplitudeEvents["PAYMENT_FAILED"] = "Payment Failed";
  AmplitudeEvents["CHECKOUT_ADDRESS"] = "Continue To Address";
  AmplitudeEvents["CHECKOUT_CUSTOMS"] = "Continue To Customs";
  AmplitudeEvents["CHECKOUT_PAYMENT"] = "Continue To Payment";
  AmplitudeEvents["SET_USER"] = "Set User";
  AmplitudeEvents["SERVICE_DETAILS"] = "Service Details";
  AmplitudeEvents["PAGE_LOAD"] = "Page load";
  AmplitudeEvents["LOAD_SINGLE_PAGE"] = "Load Single Page";
  AmplitudeEvents["LOAD_POSTSALE_PAGE"] = "Load Postsale Page";
  AmplitudeEvents["LOAD_HOME_PAGE"] = "Load Home Page";
  AmplitudeEvents["WEIGHT_SELECTED"] = "Weight Selected";
  AmplitudeEvents["DISPATCH_METHOD_SELECTED"] = "Dispatch Method Selected";
  AmplitudeEvents["ASK_FOR_INVOICE"] = "Ask for invoice";
  AmplitudeEvents["SAVE_BILLING_INFO"] = "Save billing info";
  AmplitudeEvents["CLICK_ON_BULK_MULTI_LABEL_BUTTON"] = "Click Bulk Multi Label button";
  AmplitudeEvents["CLICK_STEP"] = "Click step";
  AmplitudeEvents["CLICK_CHECK_CARRIERS_POLICIES"] = "Click on check and accept the Terms and Conditions of the transport agency";
  AmplitudeEvents["CLICK_UNCHECK_CARRIERS_POLICIES"] = "Click on uncheck the Terms and Conditions of the transport agency";
  AmplitudeEvents["SELECT_SHIPMENT_CONTENT"] = "Select shipment content";
  AmplitudeEvents["CLICK_INSURANCE_VALUE"] = "Click insurance value";
  AmplitudeEvents["CLICK_ON_INSURANCE"] = "Click on insurance";
  AmplitudeEvents["CLICK_DROPOFF_MAP"] = "Click dropoff map";
  AmplitudeEvents["PUDO_OPEN"] = "Pudo click select pickup point";
  AmplitudeEvents["PUDO_CONFIRMATION"] = "Pudo confirm pickup point";
  AmplitudeEvents["PUDO_INTERACTION"] = "Pudo user interacts with map";
  AmplitudeEvents["PUDO_FILTERING"] = "Pudo user filter in list";
  AmplitudeEvents["APPLY_PROMO_CODE"] = "Apply promo code";
  AmplitudeEvents["TRACKING_SUBMIT"] = "Click search tracking";
  AmplitudeEvents["TRACKING_CLICK_SUPPORT"] = "Click on tracking details contact support";
  AmplitudeEvents["ZENDESK_WIDGET_OPEN"] = "Open Zendesk Widget";
  AmplitudeEvents["ZENDESK_CHAT_OPEN"] = "Open chat on Zendesk Widget";
  AmplitudeEvents["ZENDESK_CALL_SUBMIT"] = "Submit digital call on Zendesk Widget";
  AmplitudeEvents["ZENDESK_WIDGET_MINIMIZED"] = "Minimize Zendesk Widget";
  AmplitudeEvents["SERVICE_LIST_OPEN_FILTERS"] = "Click on open filters";
  AmplitudeEvents["SERVICE_LIST_CLOSE_FILTERS"] = "Click on close filters";
  AmplitudeEvents["SERVICE_LIST_EDIT_FILTERS"] = "Click on edit filters";
  AmplitudeEvents["SERVICE_LIST_REMOVE_FILTERS"] = "Click on remove filters";
  AmplitudeEvents["SERVICE_LIST_APPLY_FILTERS"] = "Click on apply filters";
  AmplitudeEvents["SERVICE_LIST_APPLY_NO_FILTERS"] = "Click on apply no filters";
  AmplitudeEvents["SHOW_WEIGHT_DEVIATION_DISCLAIMER"] = "Show weight deviation disclaimer";
  AmplitudeEvents["SERVICE_LIST_APPLY_SORT"] = "Click on apply sorting";
  AmplitudeEvents["SELECT_PRIORITY_UPSELL"] = "Click on Priority to add";
  AmplitudeEvents["DESELECT_PRIORITY_UPSELL"] = "Click on Priority to remove";
  return AmplitudeEvents;
}({});
let AmplitudeProperties = /*#__PURE__*/function (AmplitudeProperties) {
  AmplitudeProperties["FROM_COUNTRY"] = "From country";
  AmplitudeProperties["TO_COUNTRY"] = "To country";
  AmplitudeProperties["POSTCODE_FROM"] = "Postcode from";
  AmplitudeProperties["POSTCODE_TO"] = "Postcode to";
  AmplitudeProperties["WEIGHT"] = "Weight";
  AmplitudeProperties["WIDTH"] = "Width";
  AmplitudeProperties["HEIGHT"] = "Height";
  AmplitudeProperties["LENGTH"] = "Length";
  AmplitudeProperties["PACKAGES"] = "Packages";
  AmplitudeProperties["SERVICE"] = "Service";
  AmplitudeProperties["SERVICES"] = "Services";
  AmplitudeProperties["CARRIER"] = "Carrier";
  AmplitudeProperties["COLLECTION_TYPE"] = "Collection type";
  AmplitudeProperties["DELIVERY_TYPE"] = "Delivery type";
  AmplitudeProperties["PRICE"] = "Price";
  AmplitudeProperties["POSITION"] = "Position";
  AmplitudeProperties["CONTENT"] = "Content";
  AmplitudeProperties["CONTENT_VALUE"] = "Content value";
  AmplitudeProperties["PROMO"] = "Promo";
  AmplitudeProperties["ERROR"] = "Error";
  AmplitudeProperties["PAYMENT_METHOD"] = "Payment method";
  AmplitudeProperties["SENDER_TYPE"] = "Sender type";
  AmplitudeProperties["FIRST_NAME"] = "First name";
  AmplitudeProperties["LAST_NAME"] = "Last name";
  AmplitudeProperties["EMAIL"] = "Email";
  AmplitudeProperties["SHIPMENT_ID"] = "Shipment ID";
  AmplitudeProperties["INSURANCE"] = "Insurance";
  AmplitudeProperties["SECTION"] = "Section";
  AmplitudeProperties["PLATFORM"] = "Platform";
  AmplitudeProperties["PLATFORM_COUNTRY"] = "Platform Country";
  AmplitudeProperties["LANGUAGE"] = "Language";
  AmplitudeProperties["TENANT"] = "Tenant";
  AmplitudeProperties["INVOICE"] = "Invoice";
  AmplitudeProperties["TYPE_OF_SERVICE"] = "type of service";
  AmplitudeProperties["CATEGORY"] = "Category";
  AmplitudeProperties["FROM_STEP"] = "From Step";
  AmplitudeProperties["TO_STEP"] = "To Step";
  AmplitudeProperties["CUSTOMS_REQUIRED"] = "Customs required";
  AmplitudeProperties["CATEGORY_NAME"] = "category name";
  AmplitudeProperties["VALUE"] = "value";
  AmplitudeProperties["ACTION"] = "action";
  AmplitudeProperties["SOURCE"] = "source";
  AmplitudeProperties["PROMO_CODE_APPLIED"] = "promo code applied";
  AmplitudeProperties["IS_VALID"] = "is valid";
  AmplitudeProperties["NUMBER_POINTS"] = "number of points";
  AmplitudeProperties["VIP_USER"] = "VIP User";
  AmplitudeProperties["DETAIL_OF_SERVICE"] = "Detail of service";
  AmplitudeProperties["TRANSIT_TIME"] = "Transit time";
  AmplitudeProperties["TAGS"] = "Tags";
  AmplitudeProperties["SERVICES_IDS"] = "Services Ids";
  AmplitudeProperties["SERVICE_ID"] = "Service Id";
  AmplitudeProperties["SERVICES_WITH_TAGS"] = "Services with tags";
  AmplitudeProperties["SERVICES_SHOWN"] = "Services shown";
  AmplitudeProperties["PRICE_BASED_POSITION"] = "Price based position";
  AmplitudeProperties["SERVICES_SORT_CRITERIA"] = "Services sort criteria";
  AmplitudeProperties["ORIGIN_STEP"] = "Origin step";
  AmplitudeProperties["LOCATION"] = "location";
  AmplitudeProperties["FEATURE_FLAGS"] = "Feature flags";
  AmplitudeProperties["PRIORITY"] = "Priority";
  return AmplitudeProperties;
}({});
let AmplitudeTypeOfServices = /*#__PURE__*/function (AmplitudeTypeOfServices) {
  AmplitudeTypeOfServices["PICK_UP"] = "pickup";
  AmplitudeTypeOfServices["DROP_OFF"] = "dropoff";
  AmplitudeTypeOfServices["COLLECTION"] = "collection";
  AmplitudeTypeOfServices["DELIVERY"] = "delivery";
  return AmplitudeTypeOfServices;
}({});
let Amplitude3DsecureProperties = /*#__PURE__*/function (Amplitude3DsecureProperties) {
  Amplitude3DsecureProperties["CARD"] = "Card";
  Amplitude3DsecureProperties["CARD_TYPE"] = "Card type";
  Amplitude3DsecureProperties["SECURE_CHECK"] = "3D secure";
  Amplitude3DsecureProperties["SECURE_ENROLLED"] = "3D secure enrolled";
  Amplitude3DsecureProperties["SECURE_STATUS"] = "3D secure status";
  Amplitude3DsecureProperties["SECURE_VERIFICATION"] = "3D secure verification";
  Amplitude3DsecureProperties["SECURE_VERSION"] = "3D secure version";
  return Amplitude3DsecureProperties;
}({});
let AmplitudeLogLevels = /*#__PURE__*/function (AmplitudeLogLevels) {
  AmplitudeLogLevels[AmplitudeLogLevels["DISABLE"] = 0] = "DISABLE";
  AmplitudeLogLevels[AmplitudeLogLevels["ERROR"] = 1] = "ERROR";
  AmplitudeLogLevels[AmplitudeLogLevels["WARN"] = 2] = "WARN";
  AmplitudeLogLevels[AmplitudeLogLevels["INFO"] = 4] = "INFO";
  return AmplitudeLogLevels;
}({});
let AmplitudeCategories = /*#__PURE__*/function (AmplitudeCategories) {
  AmplitudeCategories["CHECKOUT"] = "CONVERSION_CHECKOUT";
  AmplitudeCategories["ACQUISITION"] = "ACQUISITION";
  AmplitudeCategories["SERVICE_SEARCH"] = "SERVICE_SEARCH";
  AmplitudeCategories["POSTSALE"] = "POSTSALE";
  return AmplitudeCategories;
}({});
let AmplitudeUserProperties = /*#__PURE__*/function (AmplitudeUserProperties) {
  AmplitudeUserProperties["DATE"] = "Date";
  AmplitudeUserProperties["KOKUDO_CUSTOMS"] = "Kokudo customs";
  return AmplitudeUserProperties;
}({});
let AmplitudeServicesSortCriteria = /*#__PURE__*/function (AmplitudeServicesSortCriteria) {
  AmplitudeServicesSortCriteria["TAGGED_SERVICES"] = "Tagged services";
  AmplitudeServicesSortCriteria["TOTAL_PRICE"] = "Total price";
  AmplitudeServicesSortCriteria["BASE_PRICE"] = "Base price";
  AmplitudeServicesSortCriteria["TRANSIT_TIME"] = "Transit time";
  return AmplitudeServicesSortCriteria;
}({});
let AmplitudeTypeOfLocations = /*#__PURE__*/function (AmplitudeTypeOfLocations) {
  AmplitudeTypeOfLocations["ADDRESS_STEP"] = "address step";
  AmplitudeTypeOfLocations["PAYMENT_STEP"] = "payment step";
  AmplitudeTypeOfLocations["DRAFT"] = "draft";
  AmplitudeTypeOfLocations["CSV_IMPORT"] = "CSV import module";
  return AmplitudeTypeOfLocations;
}({});

export { Amplitude3DsecureProperties, AmplitudeCategories, AmplitudeEvents, AmplitudeLogLevels, AmplitudeProperties, AmplitudeServicesSortCriteria, AmplitudeTypeOfLocations, AmplitudeTypeOfServices, AmplitudeUserProperties };
//# sourceMappingURL=amplitude.js.map
